import { IUpdateRequestBase } from '@common/api.models';
import { IProjectTeamOption } from '@projectTeam/projectTeam.models';
import { IProject } from '@project/project.models';
import { IProjectUserProfileBase } from './projectUserProfile.models';
import { ITraining } from './training.models';

export const mySignatureFormKeys = {
  FILENAME: 'fileName',
  FILE_CONTENT: 'fileContent',
  EXISTING_SIGNATURE: 'existingSignature',
  QUALIFICATION: 'qualification',
};

export interface ISignature {
  id?: number;
  userProfileId: number;
  projectId: number;
  fileName?: string;
  fileContent?: string;
  qualification?: string;
  rowVersion: string;
  mime: string;
}

export interface IUpsertMySignatureRequestBase {
  fileName: string;
  fileContent: string;
  qualification?: string;
}

export interface ICreateMySignatureRequest extends IUpsertMySignatureRequestBase {}

export interface ICreateSignatureRequest extends IUpsertMySignatureRequestBase {
  userProfileId: number;
}
export interface IUpdateMySignatureRequest extends IUpsertMySignatureRequestBase {
  id: number;
  rowVersion: string;
}

export interface IUserProfileBase {
  id?: number;
  uid: string;
  email: string;
  upn: string;
  firstName?: string;
  lastName?: string;
  title?: string;
  tel?: string;
  fax?: string;
  lastProjectId?: number;
  lastLoginDate?: string;
  isLocked?: boolean;
  defaultRightPanelClosed?: boolean;
  loginTime?: number;
  twapprovalType?: string;
  qualification?: string;
  maxTeamBoardMasterId?: number;
  gemsLead?: boolean;
  ekpid?: string;
  employeeId?: string;
  rowVersion?: string;
  displayName: string;
  userProfileId?: number;
  isExternal?: boolean;
  isAccountCreated?: boolean;
  isResigned?: boolean;
}

export interface IUserProfile extends IUserProfileBase {
  signatureUserProfile?: ISignature;
  trainings?: ITraining[];
  projectUserProfile?: IProjectUserProfileBase[];
}

export interface IUpsertUserProfileRequest {
  uid: string;
  email: string;
  upn: string;
  firstName?: string;
  lastName?: string;
  displayName?: string;
  title?: string;
  tel?: string;
  fax?: string;
  lastProjectId?: number;
  lastLoginDate?: string;
  isLocked?: boolean;
  defaultRightPanelClosed?: boolean;
  loginTime?: number;
  twapprovalType?: string;
  qualification?: string;
  maxTeamBoardMasterId?: number;
  gemsLead?: boolean;
  ekpid?: string;
  employeeId?: string;
  isResigned?: boolean;
}

export interface ICreateUserProfileRequest extends IUpsertUserProfileRequest {}
export interface IUpdateUserProfileRequest extends IUpsertUserProfileRequest, IUpdateRequestBase {}

export interface IUserProfileOption {
  id: number;
  uid: string;
  email: string;
  upn: string;
  firstName?: string;
  lastName?: string;
  ekpid?: string;
  employeeId?: string;
  displayName?: string;
  isLocked?: boolean;
  rowVersion?: string;
}

export interface IProjectUserProfileWithTeamOption {
  projectId: number;
  team: IProjectTeamOption;
  id: number;
  uid: string;
  email: string;
  upn: string;
  firstName: string;
  lastName?: any;
  ekpid?: any;
  employeeId?: any;
  displayName: string;
  rowVersion: string;
}

export interface ISyncNoAccountUserProfileByProjectNoResponse {
  project: IProject;
  profiles: IUserProfile[];
}

export interface ISyncNoAccountUserProfileByProjectNoRequest {
  projectNo: string;
}

export interface IUpdateDummyUserProfileRequest {
  userProfileId: number;
  userProfileIdsToUpdate: number[];
}
